import React from 'react'
import Link from 'gatsby-link'
import Calendar from '../images/calendar.svg'
import View from '../images/view.svg'
import Tag from '../images/tag.svg'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
const Tags = ({ data, pathContext }) => {
  const { posts, tagName } = pathContext
  if (posts) {
    return (
      <div className="main-wrapper animated fadeIn">
        <Helmet title={`Articles about ${tagName} - ${data.site.siteMetadata.title} `} />
        <h1>
          Articles about {`{ ${tagName} }`}
          <span className="title-end">_</span>
        </h1>
        <div className="subtitle">list of posts from the selected tag.</div>
        <blockquote>
          "Don't let small minds convince you that your dreams are too big."
        </blockquote>
        <section className="blog-listing">
          {posts.map(post => {
            const { frontmatter } = post
            return (
              <article className="post-item" key={post.frontmatter.title}>
                <div className="post-thumbnail">
                  <Link to={post.frontmatter.path}>
                    <Img
                      sizes={
                        post.frontmatter.featuredImage.childImageSharp.sizes
                      }
                      className="thumbnail"
                    />
                    <div className="view-icon">
                      <img src={View} alt="Phanor Coll" />
                    </div>
                  </Link>
                </div>
                <div className="post-details">
                  <header className="post-detail">
                    <div className="title">
                      <Link to={post.frontmatter.path}>
                        {post.frontmatter.title}
                      </Link>
                    </div>
                  </header>
                  <div className="post-excerpt">{post.frontmatter.excerpt}</div>
                  <div className="post-date">
                    <div className="date-icon">
                      <img src={Calendar} alt="Phanor Coll" />
                    </div>
                    <div className="date">{post.frontmatter.date}</div>
                  </div>
                  <div className="post-tags">
                    <div className="post-icon">
                      <img src={Tag} alt="Phanor Coll" />
                    </div>
                    <div className="tag-list">
                      <ul>
                        {post.frontmatter.tags.map(tag => {
                          return (
                            <li key={tag}>
                              <Link to={`/tags/${tag}`} className="a-animation">
                                {tag}
                              </Link>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </article>
            )
          })}
        </section>
      </div>
    )
  }
}

export const pageQuery = graphql`
  query SiteInfo {
    site {
      siteMetadata {
        title
        author
      }
    }
  }
`

export default Tags



// WEBPACK FOOTER //
// ./src/templates/tags.js